<template>
  <!-- <pre>   {{ kawalanResponse }}</pre>  -->
  <Background v-if="piagamResponse && kawalanResponse">
    <div class="image-wrapper">
      <img
        src="@/assets/header/OSC 3.0 PLUS ONLINE.png"
        alt="OSC 3.0 PLUS ONLINE"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <!--
        <div class="pelayar-container">
        <h3>Bilangan Pelayar :</h3>
        <p><span class="number">110</span></p>
        </div> 
      -->

      <div class="content-wrapper1">
        <div class="date-label-container">
          <h3>Tarikh</h3>
          <AppDateTimePicker
            :key="datePickerKey"
            v-model="dateRange"
            placeholder="Select date"
            :config="{ mode: 'range' }"
            class="app-date-picker"
          />
        </div>
        <div class="button-wrapper">
          <button
            class="filter-btn"
            @click="filterData"
          >
            SARING
          </button>
        </div>
      </div>

      <h2>JUMLAH PERMOHONAN MENGIKUT KATEGORI</h2>
      <div class="image-grid">
        <div class="image-container">
          <img
            src="@/assets/osc/red.png"
            alt="Permit Sementara"
          >
          <div class="text-overlay">
            <p class="name">
              Permit Sementara
            </p>
            <p><span class="number">{{ kawalanResponse['Permit Sementara'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/blue.png"
            alt="Kebenaran Merancang"
          >
          <div class="text-overlay">
            <p class="name">
              Kebenaran Merancang
            </p>
            <p><span class="number">{{ kawalanResponse['Kebenaran Merancang'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/dark.png"
            alt="Kebenaran Merancang (Menara atau Struktur Komunikasi)"
          >
          <div class="text-overlay">
            <p class="name">
              Kebenaran Merancang (Menara atau Struktur Komunikasi)
            </p>
            <p><span class="number">{{ kawalanResponse['Kebenaran Merancang (Menara atau Struktur Komunikasi)'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/purple.png"
            alt="Pelan Landskap"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Landskap
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Landskap'] || '0' }}</span></p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/osc/light.png"
            alt="Pelan Kerja Tanah"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Kerja Tanah
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Kerja Tanah'] || '0' }}</span></p>
          </div>
        </div>
 
        <div class="image-container">
          <img
            src="@/assets/osc/green.png"
            alt="Permit Sementara (Menara atau Struktur Komunikasi)"
          >
          <div class="text-overlay">
            <p class="name">
              Permit Sementara (Menara atau Struktur Komunikasi)
            </p>
            <p><span class="number">{{ kawalanResponse['Permit Sementara (Menara atau Struktur Komunikasi)'] || '0' }}</span></p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/osc/yellow.png"
            alt="Pelan Bangunan"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Bangunan
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Bangunan'] || '0' }}</span></p>
          </div>
        </div>



        <div class="image-container">
          <img
            src="@/assets/osc/red.png"
            alt="Permit (Kerja Ubah Suai Kecil)"
          >
          <div class="text-overlay">
            <p class="name">
              Permit (Kerja Ubah Suai Kecil)
            </p>
            <p><span class="number">{{ kawalanResponse['Permit (Kerja Ubah Suai Kecil)'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/blue.png"
            alt="Permit Sementara Bangunan Rumah Pekerja Tapak Bina"
          >
          <div class="text-overlay">
            <p class="name">
              Permit Sementara Bangunan Rumah Pekerja Tapak Bina
            </p>
            <p><span class="number">{{ kawalanResponse['Permit Sementara Bangunan Rumah Pekerja Tapak Bina'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/dark.png"
            alt="Pelan Lampu Jalan"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Lampu Jalan
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Lampu Jalan'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/purple.png"
            alt="Pelan Bangunan (Menara atau Struktur Komunikasi)"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Bangunan (Menara atau Struktur Komunikasi)
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Bangunan (Menara atau Struktur Komunikasi)'] || '0' }}</span></p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/osc/light.png"
            alt="Pelan Jalan Dan Perparitan"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Jalan Dan Perparitan
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Jalan Dan Perparitan'] || '0' }}</span></p>
          </div>
        </div>
 
        <div class="image-container">
          <img
            src="@/assets/osc/green.png"
            alt="Penamaan Taman/Jalan/Bangunan (TJB)"
          >
          <div class="text-overlay">
            <p class="name">
              Penamaan Taman/Jalan/Bangunan (TJB)
            </p>
            <p><span class="number">{{ kawalanResponse['Penamaan Taman/Jalan/Bangunan (TJB)'] || '0' }}</span></p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/osc/yellow.png"
            alt="Pelan Bangunan (Tambah / Mengubah) bagi EVCB"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Bangunan (Tambah / Mengubah) bagi EVCB
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Bangunan (Tambah / Mengubah) bagi EVCB'] || '0' }}</span></p>
          </div>
        </div>


   
        <div class="image-container">
          <img
            src="@/assets/osc/red.png"
            alt="Permit Sementara bagi EVCB"
          >
          <div class="text-overlay">
            <p class="name">
              Permit Sementara bagi EVCB
            </p>
            <p><span class="number">{{ kawalanResponse['Permit Sementara bagi EVCB'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/blue.png"
            alt="Pelan Bangunan bagi Self Regulation (SR)"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Bangunan bagi Self Regulation (SR)
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Bangunan bagi Self Regulation (SR)'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/dark.png"
            alt="Pelan Kerja Tanah bagi Industrial Green Lane (IGL)"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Kerja Tanah bagi Industrial Green Lane (IGL)
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Kerja Tanah bagi Industrial Green Lane (IGL)'] || '0' }}</span></p>
          </div>
        </div>


        <div class="image-container">
          <img
            src="@/assets/osc/purple.png"
            alt="Pelan Jalan Dan Perparitan bagi Industrial Green Lane (IGL)"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Jalan Dan Perparitan bagi Industrial Green Lane (IGL)
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Jalan Dan Perparitan bagi Industrial Green Lane (IGL)'] || '0' }}</span></p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/osc/light.png"
            alt="Kebenaran Merancang bagi Industrial Green Lane (IGL)"
          >
          <div class="text-overlay">
            <p class="name">
              Kebenaran Merancang bagi Industrial Green Lane (IGL)
            </p>
            <p><span class="number">{{ kawalanResponse['Kebenaran Merancang bagi Industrial Green Lane (IGL)'] || '0' }}</span></p>
          </div>
        </div>
 
        <div class="image-container">
          <img
            src="@/assets/osc/green.png"
            alt="Pelan Bangunan bagi Industrial Green Lane (IGL)"
          >
          <div class="text-overlay">
            <p class="name">
              Pelan Bangunan bagi Industrial Green Lane (IGL)
            </p>
            <p><span class="number">{{ kawalanResponse['Pelan Bangunan bagi Industrial Green Lane (IGL)'] || '0' }}</span></p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/osc/yellow.png"
            alt="Permit  Pembinaan Kecil bagi EVCB"
          >
          <div class="text-overlay">
            <p class="name">
              Permit  Pembinaan Kecil bagi EVCB
            </p>
            <p><span class="number">{{ kawalanResponse['Permit  Pembinaan Kecil bagi EVCB'] || '0' }}</span></p>
          </div>
        </div>
        
        <div class="image-container">
          <img
            src="@/assets/osc/red.png"
            alt="Lain-Lain"
          >
          <div class="text-overlay">
            <p class="name">
              Lain-Lain
            </p>
            <p><span class="number">{{ kawalanResponse['Lain-lain'] || '0' }}</span></p>
          </div>
        </div>
      </div>
    </div>


    <div class="content-wrapper">
      <div class="pbtpay-status">
        <h2>TEMPOH PIAGAM PERMOHONAN</h2>
        <VTable
          height="450"
          class="text-no-wrap"
        >
          <thead>
            <tr>
              <th>No</th>
              <th>Nama</th>
              <th>Tempoh Minima</th>
              <th>Tempoh Maxima</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in piagamResponse || []"
              :key="index"
            >
              <td>{{ (index + 1) || 0 }}</td>
              <td>{{ item?.kpi_name || '0' }}</td>
              <td>{{ item?.days || 0 }} Hari</td>
              <td>{{ item?.max_days || 0 }} Hari</td>
            </tr>
          </tbody>
        </VTable>
      </div>
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'
import { useHttpService } from "@/httpService"
import { nextTick, onMounted, ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})






const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()



const dateRange=ref()
const kawalanResponse = ref({})
const piagamResponse = ref([])


async function loadDataFromApi() {
  try {
    const res = await fetch('https://jktgateway.kpkt.gov.my/api/kawalan-pemajuan/piagam-permohonan')
    const piagam = await res.json()

    piagamResponse.value = piagam?.data || []
  } catch (err) {
    console.error('loadDataFromApi failed:', err)
    piagamResponse.value = []
  }
}


async function loadDataFromApikawalan(dateFrom, dateTo) {
  try {
    console.log("Calling API with:", dateFrom, dateTo)

    const res = await fetch(`https://jktgateway.kpkt.gov.my/api/kawalan-pemajuan?date_from=${dateFrom}&date_to=${dateTo}&states[]=Malaysia&councils[]=semua`)
    const kawalan = await res.json()

    kawalanResponse.value = kawalan.submission_type || []
    console.log("API Response: ", kawalanResponse.value)

  } catch (err) {
    console.error('loadDataFromApikawalan failed:', err)
  }
}


function filterData() {
  if (dateRange.value && dateRange.value.length === 24) {
    const dateFrom =  dateRange.value.substring(0, 10)
    const dateTo = dateRange.value.substring(14) 

    loadDataFromApikawalan(dateFrom, dateTo)
  }
}

const datePickerKey = ref(0);

onMounted(() => {
  nextTick(() => {
    datePickerKey.value++;
  });
  loadDataFromApi()

  const defaultDateFrom = '2023-01-01T00:00:00.000Z'
  const defaultDateTo = new Date().toISOString()

  loadDataFromApikawalan(defaultDateFrom, defaultDateTo)
})
</script>

<style scoped>
.content-wrapper1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-radius: 20px;
  width: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 800px;
}

.date-label-container {
  max-width: 400px;
  width: 100%;
}

.button-wrapper {
  margin-block-start: 40px;
  margin-inline-start: 10px;
}


.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 20px;
  border-radius: 20px; 
  background-color: rgba(255, 255, 255, 65%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.pelayar-container {
  display: flex;
  align-items: baseline;
  gap: 10px; 
}

.filter-btn {
  border: none;
  border-radius: 5px;
  background-color: #13017f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 10%);
  color: white;
  cursor: pointer;
  font-size: 1rem;
  margin-inline-start: 40px;
  padding-block: 10px;
  padding-inline: 20px;
}

.filter-btn:hover {
  background-color: #001f73;
}

h2 {
  display: block;
  color: #150069;
  font-size: 20px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start !important;
}

h3 {
  position: relative;
  display: flex;
  align-items: center;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  inline-size: 160px;
  margin-block-start: 10px;
  text-align: start;
}

.filter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  inline-size: 100%;
  margin-block-end: 20px;
}

.content {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  inline-size: 100%;
}


.image-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(7, 1fr);
  inline-size: 100%;
  max-inline-size: 1600px;
}

.text-overlay {
  position: absolute;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  inline-size: 100%;
  inset-block-end: 0;
  padding-block: 20px;
  padding-inline: 0;
  text-align: center;
}

.name {
  color: white;
  font-size: 10px;
  font-weight: 600;
  margin-block-end: 25px;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 110%;
  padding-block-start: 90%;
}

.image-container img {
  position: absolute;
  block-size: 100%;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  object-fit: cover;
}


.number {
  color: #a80000;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}


.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}



@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .image-grid {
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
  }

  .text-overlay {
    padding-top: 5px; /* Adjusts the padding from the top */
    padding-bottom: 45px; /* Reduces bottom padding to balance */
  }

  .name {
    font-size: 0.8rem;
    margin-top: -5px; /* Moves the text slightly up */
  }

  .number {
    font-size: 1rem;
  }

  h2 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .image-grid {
    gap: 15px;
    grid-template-columns: repeat(2, 1fr);
  }

  .image-container {
    padding-block-start: 100%; /* Adjusted aspect ratio for smaller screens */
  }

  .name {
    font-size: 0.7rem;
  }

  .number {
    font-size: 0.9rem;
  }

  h2, h3 {
    font-size: 1rem;
  }
}
</style>
